import { type RegistrationData, Step } from '../../types';

import dictionary from './signing-helpers.dictionary.json';

export function getHeaderContent(data: RegistrationData) {
  if (data.regStep === Step.INITIAL) {
    return dictionary.sign;
  }

  if (data.regStep === Step.PASSWORD) {
    return dictionary.createPass;
  }

  if (data.regStep === Step.FINISH) {
    return dictionary.endOfRegistration;
  }

  return dictionary.codeTitle;
}
